<template>
    <div class="upload_box">
        <a-upload
            accept="image/png, image/jpeg, image/jpg"
            :file-list="fileList"
            :customRequest="customRequest"
            :max-count="props.limit"
            :multiple="false"
            :disabled="props.disabled"
            list-type="picture-card"
            @preview="handlePreview"
            @remove="removeChange"
        >
            <slot name="uploadBox">
                <div class="upload_btn_box" v-if="fileList.length < props.limit && !props.disabled">
                    <plus-outlined />
                    <div style="margin-top: 8px">上传</div>
                </div> 
            </slot>
        </a-upload> 
        <slot></slot> 

        <a-image
            :width="200"
            :style="{ display: 'none' }"
            :preview="{
                visible: previewVisible,
                onVisibleChange: value => previewVisible = value,
            }"
            :src="previewImage"
        />
    </div>
</template>

<script setup>
import { ref, watch } from "vue"; 
import { PlusOutlined } from '@ant-design/icons-vue';
import { sdkOssUpimage } from "@/api/common.js"; 
import { generateUUID } from "@/utils/function"; 
const props = defineProps({
    fileList: {
        type: Array,
        default: () => {
            return []
        }
    },
    limit: {
        type: Number,
        default: 6, 
    },
    disabled: {
        type: Boolean,
        default: false, 
    }
})
const emit = defineEmits([ "change" ])

const fileList = ref([]); 
watch(() => props.fileList, newVal => {
    // console.log("newVal===", newVal);
    if (newVal.length) {
        fileList.value = newVal; 
        fileChange(); 
    }
}, { immediate: true })

// 上传图片 
async function customRequest(fileData) { 
    if (fileList.value.length >= props.limit) {
        return 
    }

    let file = fileData.file; 
    let fileType = fileData.file.type; 
    let fileSize = fileData.file.size; 

    // 判断文件类型 
    let fileTypeList = [ "image/png", "image/jpeg", "image/jpg" ];
    if (!fileTypeList.includes(fileType)) { 
        message.error('仅支持上传png、jpeg、jpg格式的图片');
        return 
    }
    // // 判断文件大小 5M 
    // if ((fileSize/1024/1024)>5) { 
    //     message.error('上传片大小不能超过 5MB!');
    //     return 
    // }

    // let index = file.name.lastIndexOf(".");
    // let name = file.name.substring(0, index); 
    // let randomNum = new Date().getTime() + "" + Math.floor(Math.random() * (1000 + 1)); 
    // let suffix = file.name.substring(index); 
    // let fileName = name + "_" + randomNum + suffix; 
    
    let index = file.name.lastIndexOf(".");
    let suffix = file.name.substring(index); 
    let uuid = generateUUID(); 
    let fileName = uuid + suffix; 

    let client = await sdkOssUpimage(); 
    client.put(client.options.env + "/" + fileName, file).then((result) => { 
        console.log("==上传成功==", result, fileName); 
        fileList.value.push({ 
            id: fileList.value.length, 
            // name: file.name, 
            name: fileName, 
            url: result.url, 
            
        }); 

        fileChange(); 
    }); 
} 

const previewVisible = ref(false); 
const previewImage = ref(""); 
const previewTitle = ref(""); 
const handlePreview = async file => {
    if (!file.url && !file.preview) {
        file.preview = file.url;
    }
    previewImage.value = file.url || file.preview;
    previewVisible.value = true;
    previewTitle.value = file.name;
};

// 移除文件 
function removeChange(params) {
    // console.log("移除文件==", params);
    let index = fileList.value.findIndex(item => item.id == params.id); 
    fileList.value.splice(index, 1)
    fileChange() 
}

// 变化事件 
function fileChange() {
    let str = fileList.value.map(item => {
        return item.url; 
    }).join(";");
    emit("change", str)
}

</script>

<style lang="less" scoped>


</style>